import type { ContractingDealFieldHistoryEntityType } from '~/types/services/contracting';

import type { DealInformationTab } from './types';

// Bundled Experiences has no entry: Salesforce doesn't track its field history.
export const DEAL_HISTORY_ENTITY_TYPE_BY_TAB: Partial<
  Record<DealInformationTab, ContractingDealFieldHistoryEntityType>
> = {
  details: 'opportunity',
  'deal-options': 'deal_option',
  inclusions: 'deal_option_inclusion',
  egs: 'extra_guest_surcharge',
  surcharges: 'surcharge_period',
  'blackout-dates': 'blackout_date',
};

export const DEAL_INFORMATION_TABS: Array<{ label: string; value: DealInformationTab }> = [
  { label: 'Details', value: 'details' },
  { label: 'Deal Options', value: 'deal-options' },
  { label: 'Inclusions', value: 'inclusions' },
  { label: 'EGS', value: 'egs' },
  { label: 'Surcharges', value: 'surcharges' },
  { label: 'Blackout Dates', value: 'blackout-dates' },
  { label: 'Bundled Experiences', value: 'bundled-experiences' },
  { label: 'Campaign Schedules', value: 'campaign-schedules' },
];

export function getDealInformationTab(tab: string | null | undefined): DealInformationTab {
  return DEAL_INFORMATION_TABS.some((dealInformationTab) => dealInformationTab.value === tab)
    ? (tab as DealInformationTab)
    : 'details';
}
